import Swal from "sweetalert2";
import styled from "styled-components";
import { matchPath } from "react-router";
import { useDispatch } from "react-redux";
import MapView from "../components/MapView";
import Sidebar from "../components/Sidebar";
import GuidedTour from '../components/GuidedTour';
import React, { useEffect, useState } from "react";
import withReactContent from "sweetalert2-react-content";
import { FETCH_PROFILE_SUCCESS } from "../actions/types";
import { fetchProfile } from "../actions/profileActions";
import Mapboxmodal from "../components/MapModal/Mapboxmodal";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const Wrapper = styled.div`
  display: flex;
  max-height: 100vh;
  height: 100%;
`;

const MapPage = (props) => {
  const dispatch = useDispatch();
  const [accessToken, setAccessToken] = useState();
  const { user, getAccessTokenSilently } = useAuth0();

  const startGuidedTourIfUserCreatedLastSevenDays = (user) => {
    const user_created = new Date(user.created_at);
    const now = new Date();
    const seven_days_ago = new Date();
    seven_days_ago.setDate(now.getDate() - 7);
    
    if (user_created > seven_days_ago) {
      dispatch({ type: 'TOGGLE_GUIDED_TOUR', show: true });
    }
  }

  const startGuidedTourIfUserLoggedInBeforeSixMonths = (user) => {
    const user_last_login = new Date(user.updated_at);
    const now = new Date();
    const six_months_ago = new Date();
    six_months_ago.setMonth(now.getMonth() - 6);
    
    if (user_last_login < six_months_ago) {
      dispatch({ type: 'TOGGLE_GUIDED_TOUR', show: true });
    }
  }

  useEffect(() => {
    if (user === undefined) return;
    if (user === undefined || user.updated_at === undefined || user.created_at === undefined) return;

    startGuidedTourIfUserCreatedLastSevenDays(user);
    startGuidedTourIfUserLoggedInBeforeSixMonths(user);
  }, [user]);
  
  useEffect(() => {
    let fetchedAccessToken = null;
    const domain = "fastmap.us.auth0.com";
    getAccessTokenSilently({ audience: `https://${domain}/api/v2/` }).then((response) => {
      fetchedAccessToken = response;
      localStorage.clear();
      localStorage.setItem("auth0_token", fetchedAccessToken);
      localStorage.setItem("is_user_manager", 'manager' in user.metadata ? user.metadata.manager : false)
      dispatch({
        type: FETCH_PROFILE_SUCCESS,
        payload: user,
      });
      fetchProfile(dispatch);
    }).catch(() => {
      withReactContent(Swal).fire({
        title: "Error",
        text: 'Please refresh the website.',
      });
    }).finally(() => {
      setAccessToken(fetchedAccessToken);
    });

  }, [getAccessTokenSilently, user?.sub]);

  var drawerMatch = matchPath(window.location.pathname, {
    path: "/:drawer",
  });

  var projectMatch = matchPath(window.location.pathname, {
    path: "/:drawer/:projectId",
  });

  return (
    <Wrapper>
      {accessToken && <>
        <Sidebar drawerOpen={props.drawerOpen || !!drawerMatch || !!projectMatch} />
        <MapView clear_search="true" />
        <Mapboxmodal />
        <GuidedTour />
      </>}
    </Wrapper>
  );
}

export default withAuthenticationRequired(MapPage);